import { RotaryPotentiometer } from "./RotaryPotentiometer";
export default RotaryPotentiometer